import React from 'react';

function Privacy() {
  return (
    <div>
      {/* Page hero */}
      <div className="lb-page-hero">
        <div className="lb-container">
          <p className="lb-eyebrow">Privacy Policy</p>
          <h1 className="lb-title-lg">개인정보 처리방침</h1>
          <p className="lb-body">최종 수정일: 2025년 9월 17일</p>
        </div>
      </div>

      <section className="lb-section">
        <div className="lb-container" style={{ maxWidth: '800px' }}>

          {/* 개요 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <div className="lb-alert lb-alert-success" style={{ marginBottom: '16px' }}>
              ✅ <strong>개인정보 비수집 서비스</strong>: 라떼비버 노후연금 계산기는 사용자의 개인정보를 수집하지 않습니다.
              모든 계산은 브라우저에서 실시간으로 처리되며, 입력 데이터는 서버에 저장되지 않습니다.
            </div>
          </div>

          {/* 1. 수집하는 개인정보 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <h2 className="lb-title-md" style={{ marginBottom: '16px' }}>1. 수집하는 개인정보의 항목</h2>

            <h3 className="lb-title-md" style={{ fontSize: '17px', marginBottom: '12px' }}>📊 계산기 사용 시</h3>
            <div className="lb-alert lb-alert-info" style={{ marginBottom: '20px' }}>
              <ul style={{ margin: 0, paddingLeft: '18px', lineHeight: '1.9' }}>
                <li><strong>수집하지 않는 정보:</strong> 이름, 나이, 연락처, 이메일 등 개인 식별 정보</li>
                <li><strong>저장하지 않는 정보:</strong> 계산에 입력한 모든 수치 (나이, 저축액, 수익률 등)</li>
                <li><strong>추적하지 않는 정보:</strong> IP 주소, 브라우저 정보, 접속 로그 등</li>
              </ul>
            </div>

            <h3 className="lb-title-md" style={{ fontSize: '17px', marginBottom: '12px' }}>📧 문의 링크 사용 시</h3>
            <div className="lb-alert lb-alert-info">
              <ul style={{ margin: 0, paddingLeft: '18px', lineHeight: '1.9' }}>
                <li>문의하기를 클릭하면 <strong>사용자 기기의 이메일 클라이언트</strong>가 열립니다.</li>
                <li>작성하신 문의 내용은 이메일로 전달되며, <strong>본 서비스 서버에 전송되거나 저장되지 않습니다.</strong></li>
                <li>데이터는 사용자 이메일 계정과 운영자 수신함에만 존재하며, 서비스가 수집·보유하는 개인정보는 없습니다.</li>
              </ul>
            </div>
          </div>

          {/* 2. 수집 목적 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <h2 className="lb-title-md" style={{ marginBottom: '16px' }}>2. 개인정보의 수집 및 이용목적</h2>
            <div className="lb-grid-2">
              <div className="lb-card lb-card-padded">
                <div className="lb-card-icon">🧮</div>
                <h3 className="lb-title-md" style={{ marginTop: '8px' }}>계산기 서비스</h3>
                <ul style={{ paddingLeft: '18px', color: 'var(--color-text-sub)', lineHeight: '1.9', fontSize: '14px', marginTop: '8px' }}>
                  <li>연금 계산 기능 제공</li>
                  <li>시뮬레이션 결과 표시</li>
                  <li>차트 및 표 생성</li>
                  <li><strong>개인정보 수집 없음</strong></li>
                </ul>
              </div>
              <div className="lb-card lb-card-padded">
                <div className="lb-card-icon">📧</div>
                <h3 className="lb-title-md" style={{ marginTop: '8px' }}>문의 처리</h3>
                <ul style={{ paddingLeft: '18px', color: 'var(--color-text-sub)', lineHeight: '1.9', fontSize: '14px', marginTop: '8px' }}>
                  <li>이메일 클라이언트를 통한 전달</li>
                  <li>서비스에 데이터 수집·저장 없음</li>
                  <li>사용자 이메일 계정으로만 관리</li>
                  <li><strong>서버 측 개인정보 수집 없음</strong></li>
                </ul>
              </div>
            </div>
          </div>

          {/* 3. 제3자 제공 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <h2 className="lb-title-md" style={{ marginBottom: '16px' }}>3. 개인정보의 제3자 제공</h2>
            <div className="lb-alert lb-alert-info">
              🔒 <strong>제3자 제공 금지</strong>: 본 서비스는 수집한 개인정보를 어떠한 제3자에게도 제공하지 않습니다.
              단, 법령에 의해 요구되는 경우에 한하여 관련 기관에 제공할 수 있습니다.
            </div>
          </div>

          {/* 4. 외부 서비스 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <h2 className="lb-title-md" style={{ marginBottom: '16px' }}>4. 외부 서비스 이용</h2>
            <table className="lb-table">
              <thead>
                <tr>
                  <th>서비스</th>
                  <th>제공사</th>
                  <th>용도</th>
                  <th>개인정보 수집</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Firebase Hosting</td>
                  <td>Google</td>
                  <td>웹사이트 호스팅</td>
                  <td>접속 로그만 수집</td>
                </tr>
                <tr>
                  <td>Pretendard CDN</td>
                  <td>JsDelivr</td>
                  <td>폰트 제공</td>
                  <td>없음</td>
                </tr>
                <tr>
                  <td>Chart.js CDN</td>
                  <td>Chart.js Community</td>
                  <td>차트 라이브러리</td>
                  <td>없음</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* 5. 보안 조치 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <h2 className="lb-title-md" style={{ marginBottom: '16px' }}>5. 개인정보 보호를 위한 기술적/관리적 조치</h2>
            <div className="lb-grid-2">
              <div>
                <h3 className="lb-title-md" style={{ fontSize: '16px', marginBottom: '10px' }}>🛡️ 기술적 조치</h3>
                <ul style={{ paddingLeft: '18px', color: 'var(--color-text-sub)', lineHeight: '1.9', fontSize: '14px' }}>
                  <li>HTTPS 보안 통신</li>
                  <li>클라이언트 사이드 계산</li>
                  <li>서버 데이터 미저장</li>
                  <li>정기적 보안 업데이트</li>
                </ul>
              </div>
              <div>
                <h3 className="lb-title-md" style={{ fontSize: '16px', marginBottom: '10px' }}>📋 관리적 조치</h3>
                <ul style={{ paddingLeft: '18px', color: 'var(--color-text-sub)', lineHeight: '1.9', fontSize: '14px' }}>
                  <li>최소 개인정보 수집 원칙</li>
                  <li>데이터 처리 목적 명시</li>
                  <li>서버 미저장 원칙 준수</li>
                  <li>정기적 처리방침 검토</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 6. 권리 행사 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <h2 className="lb-title-md" style={{ marginBottom: '16px' }}>6. 개인정보 관련 권리 행사</h2>
            <p className="lb-body" style={{ marginTop: 0 }}>정보주체는 언제든지 다음과 같은 권리를 행사할 수 있습니다:</p>
            <div className="lb-grid-2" style={{ marginTop: '16px' }}>
              <div className="lb-card lb-card-padded">
                <h3 className="lb-title-md" style={{ fontSize: '16px' }}>🔍 열람 요구권</h3>
                <p className="lb-card-desc">개인정보 처리 현황을 확인할 수 있습니다.</p>
              </div>
              <div className="lb-card lb-card-padded">
                <h3 className="lb-title-md" style={{ fontSize: '16px' }}>✏️ 정정·삭제권</h3>
                <p className="lb-card-desc">개인정보의 수정이나 삭제를 요구할 수 있습니다.</p>
              </div>
            </div>
            <div className="lb-alert lb-alert-info" style={{ marginTop: '16px' }}>
              <strong>권리 행사 방법:</strong> 문의 페이지를 통한 온라인 신청 → 본인 확인 절차 후 영업일 기준 10일 이내 처리
            </div>
          </div>

          {/* 7. 문의 */}
          <div className="lb-card lb-card-padded">
            <h2 className="lb-title-md" style={{ marginBottom: '12px' }}>7. 개인정보 관련 문의</h2>
            <p className="lb-body" style={{ marginTop: 0 }}>
              개인정보 처리방침에 대한 문의사항이나 개인정보 관련 권리 행사를 원하시는 경우 문의 페이지를 통해 연락해 주시기 바랍니다.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}

export default Privacy;
